import { render } from "./ConfigurationLabels.vue?vue&type=template&id=62e97b2a&scoped=true"
import script from "./ConfigurationLabels.vue?vue&type=script&lang=js"
export * from "./ConfigurationLabels.vue?vue&type=script&lang=js"

import "./ConfigurationLabels.vue?vue&type=style&index=0&id=62e97b2a&scoped=true&lang=scss"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62e97b2a"]])

export default __exports__